import React from 'react'
import { $post } from '@/api'
import domain from '@/api/config'
import { getBEMCls } from '@/utils/classname'
import { layerManage } from '@/utils/layer'
import $msg from '@/utils/message'
import { shopStore } from '@/store/shop'
import { BaseDialog } from '@/components/dialog/base-dialog'
import Button from '@/components/button/button'

import './staff-seat-purchase-sheet.scss'

const StaffSeatPurchaseSheet: React.FC = () => {
    const cls = (...arg: string[]) => getBEMCls('staff-seat-purchase-sheet', ...arg)
    const [price, setPrice] = React.useState<number | null>(null)
    const [feeCode, setFeeCode] = React.useState<number | null>(null)
    const [purchaseCount, setPurchaseCount] = React.useState(1)
    const [purchaseCountInput, setPurchaseCountInput] = React.useState('1')
    const [isPriceLoaded, setIsPriceLoaded] = React.useState(false)

    React.useEffect(() => {
        $post<{ fee_infos: Array<{ price: number; fee_code: number }> }, {}>({
            url: '/valueaddedservices/staffseatpayinfo',
        })
            .then(res => {
                const feeInfo = res.fee_infos[0]
                setPrice(+feeInfo.price)
                setFeeCode(feeInfo.fee_code)
                setIsPriceLoaded(true)
            })
            .catch(e => {
                setIsPriceLoaded(false)
                $msg('error', e.message || '获取员工位价格失败')
            })
    }, [])

    React.useEffect(() => {
        setPurchaseCountInput(`${purchaseCount}`)
    }, [purchaseCount])

    const close = () => {
        layerManage.pop()
    }

    const toPurchase = () => {
        const shopInfo = shopStore.shopInfo
        if (!shopInfo || !feeCode) {
            return $msg('error', '获取员工位价格失败，请稍后重试')
        }
        const params = new URLSearchParams({
            shop_id: `${shopInfo.id}`,
            shop_type: 'new_ls',
            fee_code: `${feeCode}`,
            count: `${purchaseCount}`,
            shop_super_admin_passport_id: `${shopInfo.creator && shopInfo.creator.passport_id}`,
        })
        window.location.href = `${domain.center}/#/main/paymentCenter?${params.toString()}`
    }

    const updatePurchaseCountInput = (value: string) => {
        const nextValue = value.replace(/[^\d]/g, '')

        if (!nextValue) {
            setPurchaseCountInput('')
            return
        }

        const nextCount = Math.max(1, Number(nextValue))
        setPurchaseCount(nextCount)
        setPurchaseCountInput(`${nextCount}`)
    }

    const normalizePurchaseCountInput = () => {
        if (!purchaseCountInput) {
            setPurchaseCount(1)
            setPurchaseCountInput('1')
        }
    }

    const canPay = isPriceLoaded && feeCode != null && price != null

    return (
        <BaseDialog isShow title="订单确认" width={420} onClose={close}>
            <div className={cls('content')}>
                <div className={cls('row')}>
                    <div className={cls('label')}>购买服务：</div>
                    <div className={cls('value')}>员工数量上限</div>
                </div>
                <div className={cls('row')}>
                    <div className={cls('label')}>购买数量：</div>
                    <div className={cls('counter')}>
                        <button
                            type="button"
                            className={`${cls('operator')} ${
                                purchaseCount <= 1 ? cls('operator', 'disabled') : ''
                            }`.trim()}
                            disabled={purchaseCount <= 1}
                            onClick={() => {
                                if (purchaseCount > 1) {
                                    setPurchaseCount(purchaseCount - 1)
                                }
                            }}
                        >
                            -
                        </button>
                        <input
                            type="text"
                            inputMode="numeric"
                            className={cls('count-input')}
                            value={purchaseCountInput}
                            onChange={e => {
                                updatePurchaseCountInput(e.target.value)
                            }}
                            onBlur={normalizePurchaseCountInput}
                        />
                        <button
                            type="button"
                            className={cls('operator')}
                            onClick={() => setPurchaseCount(purchaseCount + 1)}
                        >
                            +
                        </button>
                    </div>
                </div>
                <div className={cls('row')}>
                    <div className={cls('label')}>单价：</div>
                    <div className={cls('value')}>￥{price ? price.toFixed(2) : '--'}/个</div>
                </div>
                <div className={cls('row')}>
                    <div className={cls('label')}>有效期：</div>
                    <div className={cls('value')}>一年</div>
                </div>
                <div className={cls('row', 'total')}>
                    <div className={cls('label')}>订单总价：</div>
                    <div className={cls('price')}>￥{((price || 0) * purchaseCount).toFixed(2)}</div>
                </div>
            </div>
            <div className={cls('footer')}>
                <Button types="default" onClick={toPurchase} disabled={!canPay}>
                    立即支付
                </Button>
                <Button types="primary" onClick={close}>
                    取消
                </Button>
            </div>
        </BaseDialog>
    )
}

export default StaffSeatPurchaseSheet
